import { render, staticRenderFns } from "./CommonStoreHeader.vue?vue&type=template&id=ca049cf6&scoped=true"
import script from "./CommonStoreHeader.vue?vue&type=script&lang=js"
export * from "./CommonStoreHeader.vue?vue&type=script&lang=js"
import style0 from "./CommonStoreHeader.vue?vue&type=style&index=0&id=ca049cf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca049cf6",
  null
  
)

export default component.exports